// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splitter-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

/* Container for center + bottom, takes all remaining vertical space */
.middle-stack {
  flex: 1 1;              /* flexible height */
  display: flex;
  flex-direction: column;
  min-height: 0;        /* VERY important */
}
.divider-horizontal-internal {
  background-color:#74717187;
  height: 1px;
  cursor: row-resize;
}

.panel.center {
  overflow: auto;
  background-color: #fff;
}


/* Vertical split: left | center | right */
.splitter-vertical {
  display: flex;
  flex: 1 1;              /* takes available height in middle-stack */
  min-height: 0;        /* prevents overflow */
  overflow: hidden;
}

/* Panels */
.panel {
  overflow: auto;
  background-color: #f5f5f5;
}

.panel.center {
  flex: 1 1;              /* flexible width & height */
  min-width: 0;
  min-height: 0;        /* critical for vertical flex shrinking */
  background-color: #fff;
}

.panel.left, .panel.right {
  flex-shrink: 0;       /* fixed width from state */
}

/* Dividers */
.divider {
  width: 1px;
  cursor: col-resize;
  background-color: #74717187;
  position: relative; /* Ensure positioning context */
  z-index: 10;
}
.divider:hover {
  transform: scaleX(5); /* This will visually "increase" height without affecting the interactive area */
  background-color: #0c44b587;
  z-index: 20; /* Higher z-index on hover */
}

.divider-horizontal {
  height: 2px;
  cursor: row-resize;
  background-color: #74717187;
  position: relative; /* Ensure positioning context */
  z-index: 10;
}

.divider-horizontal:hover {
  transform: scaleY(5); /* This will visually "increase" height without affecting the interactive area */
  background-color: #0c44b587;
  z-index: 20; /* Higher z-index on hover */
}










`, "",{"version":3,"sources":["webpack://./src/components/Splitter/Splitter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,SAAO,eAAe,oBAAoB;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa,SAAS,mBAAmB;AAC3C;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;;AAGA,0CAA0C;AAC1C;EACE,aAAa;EACb,SAAO,eAAe,2CAA2C;EACjE,aAAa,SAAS,sBAAsB;EAC5C,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO,eAAe,4BAA4B;EAClD,YAAY;EACZ,aAAa,SAAS,yCAAyC;EAC/D,sBAAsB;AACxB;;AAEA;EACE,cAAc,QAAQ,2BAA2B;AACnD;;AAEA,aAAa;AACb;EACE,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB,EAAE,+BAA+B;EACnD,WAAW;AACb;AACA;EACE,oBAAoB,EAAE,gFAAgF;EACtG,2BAA2B;EAC3B,WAAW,EAAE,4BAA4B;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB,EAAE,+BAA+B;EACnD,WAAW;AACb;;AAEA;EACE,oBAAoB,EAAE,gFAAgF;EACtG,2BAA2B;EAC3B,WAAW,EAAE,4BAA4B;AAC3C","sourcesContent":[".splitter-root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* Container for center + bottom, takes all remaining vertical space */\n.middle-stack {\n  flex: 1;              /* flexible height */\n  display: flex;\n  flex-direction: column;\n  min-height: 0;        /* VERY important */\n}\n.divider-horizontal-internal {\n  background-color:#74717187;\n  height: 1px;\n  cursor: row-resize;\n}\n\n.panel.center {\n  overflow: auto;\n  background-color: #fff;\n}\n\n\n/* Vertical split: left | center | right */\n.splitter-vertical {\n  display: flex;\n  flex: 1;              /* takes available height in middle-stack */\n  min-height: 0;        /* prevents overflow */\n  overflow: hidden;\n}\n\n/* Panels */\n.panel {\n  overflow: auto;\n  background-color: #f5f5f5;\n}\n\n.panel.center {\n  flex: 1;              /* flexible width & height */\n  min-width: 0;\n  min-height: 0;        /* critical for vertical flex shrinking */\n  background-color: #fff;\n}\n\n.panel.left, .panel.right {\n  flex-shrink: 0;       /* fixed width from state */\n}\n\n/* Dividers */\n.divider {\n  width: 1px;\n  cursor: col-resize;\n  background-color: #74717187;\n  position: relative; /* Ensure positioning context */\n  z-index: 10;\n}\n.divider:hover {\n  transform: scaleX(5); /* This will visually \"increase\" height without affecting the interactive area */\n  background-color: #0c44b587;\n  z-index: 20; /* Higher z-index on hover */\n}\n\n.divider-horizontal {\n  height: 2px;\n  cursor: row-resize;\n  background-color: #74717187;\n  position: relative; /* Ensure positioning context */\n  z-index: 10;\n}\n\n.divider-horizontal:hover {\n  transform: scaleY(5); /* This will visually \"increase\" height without affecting the interactive area */\n  background-color: #0c44b587;\n  z-index: 20; /* Higher z-index on hover */\n}\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
